import { useTransactionContext } from 'context/hooks/useTransactionContext';
import { useEffect } from 'react'
import { formatCurrency } from 'utils'
import { usePayableAmount } from 'context/hooks/usePayableAmount'

// `amount` is kept so existing callers still compile; what is shown is the total for the method the customer paid with
const Success = ({ amount }: { amount?: number }) => {
  const { ceviantTransactionId, merchantName } = useTransactionContext()
  const { displayTotal } = usePayableAmount()

  useEffect(() => {
    const timer = setTimeout(() => window.parent.postMessage({
      message: 'ceviantPaymentSuccess',
      payload: ceviantTransactionId
    }, '*'), 2000);
    return () => clearTimeout(timer);
  }, [amount, ceviantTransactionId])

  return (
    <div className='space-y-4 text-[#535353] font-semibold text-2xl p-6 flex flex-col items-center text-center justify-center'>
      <h2>Payment Successful</h2>
      <p className='text-[#9E9E9E] text-xl'>You paid {formatCurrency(displayTotal / 100, 'NGN')} to {merchantName}</p>
    </div>
  )
}

export default Success